/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * Template API
 * Something something. <br><br>The spec is available at <a href='/swagger/api.json'>/swagger/api.json</a>.
 * OpenAPI spec version: 0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ApiAppError,
  CreateCustomerRequest,
  CreateCustomerResponse,
  GetCustomerResponse,
  GetCustomersResponse,
  UpdateCustomerRequest,
  UpdateCustomerResponse
} from './schemas'
import { getApi } from '../client';
import type { ErrorType, BodyType } from '../client';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Create Customer
 */
export const createCustomer = (
    createCustomerRequest: BodyType<CreateCustomerRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<CreateCustomerResponse>(
      {url: `/customer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomerRequest, signal
    },
      options);
    }
  


export const getCreateCustomerMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CreateCustomerRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CreateCustomerRequest>}, TContext> => {
    
const mutationKey = ['createCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomer>>, {data: BodyType<CreateCustomerRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomer>>>
    export type CreateCustomerMutationBody = BodyType<CreateCustomerRequest>
    export type CreateCustomerMutationError = ErrorType<ApiAppError>

    /**
 * @summary Create Customer
 */
export const useCreateCustomer = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CreateCustomerRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof createCustomer>>,
        TError,
        {data: BodyType<CreateCustomerRequest>},
        TContext
      > => {

      const mutationOptions = getCreateCustomerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete Customer
 */
export const deleteCustomer = (
    id: string,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<void>(
      {url: `/customer/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCustomerMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomer>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomer(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomer>>>
    
    export type DeleteCustomerMutationError = ErrorType<ApiAppError>

    /**
 * @summary Delete Customer
 */
export const useDeleteCustomer = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomer>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCustomerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Customer by Customer Number
 */
export const getCustomerbyCustomerNumber = (
    id: number,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetCustomerResponse>(
      {url: `/customer/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCustomerbyCustomerNumberQueryKey = (id: number,) => {
    return [`/customer/${id}`] as const;
    }

    
export const getGetCustomerbyCustomerNumberQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError = ErrorType<ApiAppError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerbyCustomerNumberQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>> = ({ signal }) => getCustomerbyCustomerNumber(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerbyCustomerNumberQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>>
export type GetCustomerbyCustomerNumberQueryError = ErrorType<ApiAppError>


export function useGetCustomerbyCustomerNumber<TData = Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError = ErrorType<ApiAppError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>,
          TError,
          Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerbyCustomerNumber<TData = Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError = ErrorType<ApiAppError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>,
          TError,
          Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerbyCustomerNumber<TData = Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError = ErrorType<ApiAppError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Customer by Customer Number
 */

export function useGetCustomerbyCustomerNumber<TData = Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError = ErrorType<ApiAppError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerbyCustomerNumberQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Customer by Customer Number
 */
export const prefetchGetCustomerbyCustomerNumber = async <TData = Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerbyCustomerNumber>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCustomerbyCustomerNumberQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * @summary Update Customer
 */
export const updateCustomer = (
    id: number,
    updateCustomerRequest: BodyType<UpdateCustomerRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateCustomerResponse>(
      {url: `/customer/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomerRequest
    },
      options);
    }
  


export const getUpdateCustomerMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<UpdateCustomerRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<UpdateCustomerRequest>}, TContext> => {
    
const mutationKey = ['updateCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomer>>, {id: number;data: BodyType<UpdateCustomerRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCustomer(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomer>>>
    export type UpdateCustomerMutationBody = BodyType<UpdateCustomerRequest>
    export type UpdateCustomerMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Customer
 */
export const useUpdateCustomer = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<UpdateCustomerRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomer>>,
        TError,
        {id: number;data: BodyType<UpdateCustomerRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateCustomerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Customers
 */
export const getCustomers = (
    
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetCustomersResponse>(
      {url: `/customers`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCustomersQueryKey = () => {
    return [`/customers`] as const;
    }

    
export const getGetCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getCustomers>>, TError = ErrorType<ApiAppError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomers>>> = ({ signal }) => getCustomers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomers>>>
export type GetCustomersQueryError = ErrorType<ApiAppError>


export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = ErrorType<ApiAppError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = ErrorType<ApiAppError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = ErrorType<ApiAppError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Customers
 */

export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = ErrorType<ApiAppError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Customers
 */
export const prefetchGetCustomers = async <TData = Awaited<ReturnType<typeof getCustomers>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCustomersQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


